import React, { Component, Fragment } from 'react';
import Rest from "../../services/Rest";
import Can from "../../config/Can";
import { withRouter } from "react-router-dom";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Link } from "react-router-dom";

const istate = {
    hidden: "hidden",
    actividad: []
}

class rusers extends Component {

    constructor(props) {
        super(props)
        this.Can = new Can();
        this.Rest = new Rest();
        this.datauser = JSON.parse(localStorage.getItem("ls")) || [];
        this.state = { ...istate }
    }


    componentDidMount() {
        this.Rest.get('reportes/usuarios/' + this.props.match.params.id, this.datauser)
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        actividad: response.data,
                        hidden: ""
                    })
                }
                else {
                    if (response.status === 404) {
                        localStorage.removeItem('ls');
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: "El usuario no tiene actividad."
                        })
                    }
                }
            })
            .catch(err => {
                this.setState({
                    error: true,
                    messageError: "Error de respuesta desde el servidor."
                })
            })
    }

    handlePrint() {
        const input = document.getElementById('toprint');
        html2canvas(input)
            .then((canvas) => {
                const pdf = new jsPDF("1", "mm", "a4");
                const imgData = canvas.toDataURL('image/png', 1.0);
                pdf.addImage(imgData, 'JPEG', 0, 0);
                pdf.save("reporte.pdf");
            })

    }


    render() {
        const { hidden, actividad } = this.state
        return (
            <Fragment>

                <div className="container mt-5">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="dashboard-panel">
                                <div id="toprint">
                                    <h3>Reporte de {actividad.usuario}</h3>
                                    <div className={hidden}>
                                        <table className="table table-sm table-condensed">
                                            <thead>
                                                <tr>
                                                    <th>Nombre campaña</th>
                                                    <th>Mensaje</th>
                                                    <th>Fecha y hora de inicio</th>
                                                    <th>Fecha y hora de finalización</th>
                                                    <th>Estado de la campaña</th>
                                                </tr>
                                                {actividad.total_campañas > 0 ? actividad.campañas.map((camp, index) => (
                                                    <tr key={index}>
                                                        <th>{camp.nombre}</th>
                                                        <th>{camp.mensaje}</th>
                                                        <th>{camp.fechaInicio} {camp.horaInicio}</th>
                                                        <th>{camp.fechaFinalizacion} {camp.horaFinalizacion}</th>
                                                        <th>{camp.estatus === "1" ? <span className="badge badge-success">Habilitada</span> : <span className="badge badge-danger">Deshabilitada</span>}</th>
                                                    </tr>
                                                )) :
                                                    <tr>
                                                        <td colSpan="5">
                                                            <div className="alert alert-warning">
                                                                Este usuario no tiene actividad
                                                                </div>
                                                        </td>
                                                    </tr>}
                                                <tr>
                                                    <th colSpan="5">
                                                        Total de campañas del usuario: {actividad.total_campañas}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th colSpan="5">
                                                        Total de mensajes: {actividad.total_mensajes}
                                                    </th>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container mt-5">
                    <div className="d-flex">
                        <div className="mr-auto">
                            <button className="btn btn-primary" onClick={() => this.handlePrint()}>Imprimir</button>
                            <Link to="/actividad-del-cliente" className="btn btn-secondary ml-3">&laquo; Volver</Link>
                        </div>
                    </div>
                </div>

            </Fragment>
        );
    }
}
export default withRouter(rusers);


// WEBPACK FOOTER //
// ./src/components/reports/rusers.js